export enum CountryCurrency {
  EUR = 'EUR'
}
